interface ToastProps {
  message: string;
  visible: boolean;
}

export default function Toast({ message, visible }: ToastProps) {
  if (!visible) return null;
  return (
    <div className="fixed left-1/2 -translate-x-1/2 bottom-24 z-[80] animate-fade-up">
      <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-foreground-950 text-background-50 text-sm">
        <i className="ri-checkbox-circle-fill text-accent-400" />
        {message}
      </div>
    </div>
  );
}